import React, { useState } from "react";
import { useQuery } from "@apollo/client";
// @ts-ignore
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import loadingAnimation from "../../loadingAnimation2.json";

import { USER_TERMS_AND_CONDITIONS } from "../../services/graphql/pimcoreDam";
import { RootState } from "../../rootReducer";
import { useTranslation } from "react-i18next";

export default function TermsAndConditions() {
  const UserInfoSlice = useSelector((state: RootState) => state.user);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  // retrieve the current terms & conditions content
  const currentTermsAndConditions = () => {
    const { t } = useTranslation("common");
    const { loading, error, data } = useQuery(USER_TERMS_AND_CONDITIONS, {
      variables: {
        id: Number(UserInfoSlice?.id),
      },
      fetchPolicy: "network-only",
    });
    if (loading) {
      return (
        <div className="loaderContainer">
          <BeatLoader size={50} color="#0C2658" />
          <h1>{t("Loading...")}</h1>
        </div>
      );
    }
    if (error) return [];
    const termsAndConditionsContent = DOMPurify.sanitize(
      data.getUser.termsAndConditions.termsConditionsContent
    );
    return (
      /* eslint-disable react/no-danger */
      <div dangerouslySetInnerHTML={{ __html: termsAndConditionsContent }} />
    );
  };

  return (
    <form action="">
      <div className="row form-row">
        <div className="col-12">{currentTermsAndConditions()}</div>
      </div>
    </form>
  );
}
